// Payment details URL filters (pure): view=awaiting|history (default: queue), since=YYYY-MM, month=YYYY-MM.
import { since_month_error } from './adapters';
import { ist_month_key } from '../shared/ist';

export const VIEW_PENDING = 'pending';
export const VIEW_AWAITING = 'awaiting';
export const VIEW_HISTORY = 'history';
export const PAYMENT_DETAILS_URL_KEYS = ['view', 'since', 'month'];

const VIEWS = [VIEW_AWAITING, VIEW_HISTORY];
const valid_month = (v) => !!v && !since_month_error(v);

// month: the shell's ?month= (kept across tabs), else the current IST month.
export const parse_payment_details_filters = (search, now = new Date()) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const since = (qs.get('since') || '').trim();
  const month = (qs.get('month') || '').trim();
  const view = qs.get('view');
  return {
    view: VIEWS.includes(view) ? view : VIEW_PENDING,
    since: valid_month(since) ? since : '',
    month: valid_month(month) ? month : ist_month_key(now)
  };
};

export const payment_details_query = ({ view, since, month }) => ({
  view: VIEWS.includes(view) ? view : '',
  since: since || '',
  month: month || ''
});
